import { PaymentMethodsForm } from '../types/PaymentMethodsForm'

export const getDefaultValues = (predefinedValues?: Partial<PaymentMethodsForm>): PaymentMethodsForm => {
  return {
    bank: predefinedValues?.bank || '',
    iban: predefinedValues?.iban || '',
    offlinePayment: predefinedValues?.offlinePayment || '',
    paypalEmail: predefinedValues?.paypalEmail || '',
    swift: predefinedValues?.swift || '',
  }
}
